import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/constants";

const OPTIONS = [
  { title: "Executive Briefing", body: "A focused conversation for leadership teams exploring AI, technology, and organizational change." },
  { title: "Half-Day Workshop", body: "An intensive professional development session built around a specific business or educational challenge." },
  { title: "Full-Day Professional Development", body: "A complete learning experience combining strategy, demonstrations, hands-on exercises, and implementation planning." },
  { title: "Multi-Session Program", body: "Professional development delivered over several sessions to support deeper learning and adoption." },
  { title: "AI-Ready Organization Program", body: "A broader engagement combining leadership strategy, employee training, workflow identification, and follow-up implementation support." },
];

export default function Engagements() {
  return (
    <section id="training" data-testid="engagements-section" className="py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Engagement Options
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-4xl">
          From one powerful session to an <span className="italic text-primary">organization-wide initiative.</span>
        </motion.h2>

        <div className="mt-20 divide-y divide-[#D8D4CA] border-y border-[#D8D4CA]">
          {OPTIONS.map((o, i) => (
            <motion.div
              key={o.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: "easeOut" }}
              data-testid={`engagement-option-${i}`}
              className="py-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-baseline"
            >
              <span className="md:col-span-1 font-display text-2xl text-primary/70">0{i + 1}</span>
              <h3 className="md:col-span-4 font-display text-2xl sm:text-3xl tracking-tight">{o.title}</h3>
              <p className="md:col-span-7 text-base leading-relaxed font-light text-foreground/75">{o.body}</p>
            </motion.div>
          ))}
        </div>

        <motion.button
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          onClick={() => scrollToSection("#contact")}
          data-testid="engagements-cta-button"
          className="mt-14 inline-flex items-center gap-3 rounded-full bg-primary text-primary-foreground px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-lg hover:shadow-primary/20 transition-transform duration-300"
        >
          Discuss Your Organization
          <ArrowRight className="w-5 h-5" />
        </motion.button>
      </div>
    </section>
  );
}
